import * as _ from 'lodash';

import ReducerCreator from '../registerReducer';
import * as ACTIONS from './ticketTypes.constants';
import { TicketType } from '../../models';
import { StoreItemId, StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../../stateManagement/application/application.constants';

function onError(payload: any, dictionary: any): StoreItemId<TicketType> {
    const si = new StoreItemId<TicketType>();

    si.isLoading = false;
    si.isLoaded = true;
    si.hasError = true;
    si.error = payload;
    si.dictionary = (Object as any).assign({}, dictionary);

    return si;
}

const r = new ReducerCreator<TicketType>()
    .register<TicketType[]>(ACTIONS.TICKET_TYPES_LOAD, (state) => {
        return (Object as any).assign({}, state, { isLoading: true, isLoaded: false });
    })
    .register<TicketType[]>(ACTIONS.TICKET_TYPES_LOAD_SUCCESS, (state, payload) => {
        const newState = new StoreItemId<TicketType>();

        newState.isLoading = false;
        newState.isLoaded = true;
        newState.hasError = false;
        newState.error = null;
        newState.dictionary = {};
        payload.forEach(type => newState.dictionary[type.id] = type);

        return newState;
    })
    .register<TicketType[]>(ACTIONS.TICKET_TYPES_LOAD_ERROR, (state, payload) => {
        return onError(payload, state.dictionary);
    })
    .register<TicketType[]>(APPLICATION_DISCONNECTED, (state, payload) => {
        return new StoreItemId<TicketType>();
    })
    ;

export function ticketTypesReducer(state: StoreItem<TicketType> = new StoreItem<TicketType>(), action: { type: string; payload: any; }) {
    return r.reduce(state, action);
}
